export default __webpack_public_path__ + "static/media/ArrowUp.f518d516.svg";